module.exports = __webpack_public_path__ + "img/tree-branch.90c8b378.svg";